export var VNodeType;
(function (VNodeType) {
    VNodeType[VNodeType["ElementNode"] = 1] = "ElementNode";
    VNodeType[VNodeType["TextNode"] = 3] = "TextNode";
    VNodeType[VNodeType["CommentNode"] = 8] = "CommentNode";
    VNodeType[VNodeType["DocumentNode"] = 9] = "DocumentNode";
    VNodeType[VNodeType["HTMLNode"] = 10] = "HTMLNode";
    VNodeType[VNodeType["DocumentFragmentNode"] = 11] = "DocumentFragmentNode";
})(VNodeType || (VNodeType = {}));
